<template>
    <div class="card ob1-push bg-dark ob1-push-zigzag ob1-push-zigzag-odd p-0">
        <div class="card-item px-0 d-flex justify-content-center align-items-center h-100 pt-2 pt-md-0">
            <img
                loading="lazy"
                :alt="dto.alt"
                class="img-fluid image"
                :src="dto.picture"
            >
        </div>
        <div class="card-item h-100 p-2 bg-dark text-white">
            <div class="px-md-1 px-xl-5 align-self-center text-center">
                <strong
                    class="ob1-tag ob1-tag-inverse ob1-tag-primary mx-auto mb-1"
                >
                    {{ dto.tag }}
                </strong>
                <h3 class="h4 mb-1 mx-auto" v-html="dto.title" />
                <p class="card-text text-white col-8 col-md-12 mx-auto" v-html="dto.description" />
                <a
                    class="btn btn-secondary btn-inverse"
                    target="_blank"
                    :href="dto.linkUrl"
                    :data-oevent-category="dto.linkTms.category"
                    :data-oevent-label="dto.linkTms.label"
                    :data-oevent-action="dto.linkTms.action"
                >
                    {{ dto.linkLabel }}
                </a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "DemenagementHomeServicesPush",
    props: {
        dto: {
            type: Object,
            required: true
        }
    }
};
</script>
<style scoped lang="scss">
@import 'ob1_variables';
.image {
    max-width: 100%;
    @media (min-width: #{map-get($grid-breakpoints, md)}) {
        max-width: 60%;
    }
}
</style>
